export default __webpack_public_path__ + "static/step8-86c5e50a747e76166144553e0d2c5279.svg";